import { postRequest } from 'services/requests';

const services = {
    createSubmissions: (body) => postRequest(`/batch/submissions`, body),
    sendInvitations: (body) => postRequest(`/batch/invitations`, body),
};

export default services;
